import { render, staticRenderFns } from "./NewDiscardsModal.vue?vue&type=template&id=58b19a64&"
import script from "./NewDiscardsModal.vue?vue&type=script&lang=js&"
export * from "./NewDiscardsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewDiscardsModal.vue"
export default component.exports